import instance from "../_http";

export default {

  /**
   * 查询
   * @param {*} query
   * @returns
   */
  query: (query, page) => {
    return instance.get("/api/screen/customs-container/page", {
      params: { ...query, page: page.page, size: page.size, sort: page.sort },
    });
  },
  /**
   * 详情
   * @param {*} id
   * @returns
   */
  detail: (id) => {
    return instance.get(`api/screen/customs-container/${id}`);
  },

};
